import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const StackBarGraph = ({ data }) => {
  const modifiedData = data.map((item) => ({
    ...item,
    supplier_label: `${item.supplier_name} (${item.module_wattage})`,
  }));

  const chartData = {
    labels: modifiedData.map((item) => item.supplier_label),
    datasets: [
      {
        label: "Total Planned Modules",
        data: modifiedData.map((item) => item.total_planned_modules),
        backgroundColor: "#8884d8",
        barThickness: 30, // Wider bar
      },
            {
        label: "Produced Modules",
        data: modifiedData.map((item) => item.produced_modules),
        backgroundColor: "#36A2EB",
        barThickness: 30, // Thinner bar to appear inside
      },
      {
        label: "PDI Modules",
        data: modifiedData.map((item) => item.module_count_pdi),
        backgroundColor: "#82ca9d",
        barThickness: 30, // Thinner bar to appear inside
      },

      {
        label: "Shipped Modules",
        data: modifiedData.map((item) => item.no_of_modules_shipped),
        backgroundColor: "#FF6384",
        barThickness: 30, // Thinner bar to appear inside
      },
    ],
  };

  const options = {
    indexAxis: "y", // Horizontal bars
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: false, // Disable stacking
        beginAtZero: true,
      },
      y: {
        stacked: false, // Disable stacking
      },
    },
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div style={{ height: "400px", width: "100%" }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default StackBarGraph;